@if (isVisible) {
    <div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
        <div class="card-header fs-5 fw-medium">Nestle Details</div>
        <div class="card-body">
            <div class="px-3 row g-3 mb-4">
                @if (status) {
                    <div class="col-12">
                        <span class="fw-medium me-2">Nestle Status:</span>
                        <span class="badge" [ngClass]="getStatusBadgeClass(status)">{{ status | nestleStatus }}</span>
                    </div>
                }
                <div class="col-md-4">
                    <label class="form-label">ADP Hire Date</label>
                    <dx-date-box
                        [(value)]="details.adpHireDate"
                        type="date"
                        [displayFormat]="dateFormat"
                        [showClearButton]="true"
                        stylingMode="filled"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="ADP Hire Date is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">New Hire</label>
                    <dx-select-box
                        [(value)]="details.newHire"
                        [items]="yesNoOptions"
                        valueExpr="value"
                        displayExpr="text"
                        placeholder="Select..."
                        [showClearButton]="true"
                        stylingMode="filled"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="New Hire is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Agency</label>
                    <dx-text-box
                        [(value)]="details.agency"
                        [maxLength]="100"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="Agency is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Position ID</label>
                    <dx-text-box
                        [(value)]="details.positionId"
                        [maxLength]="40"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="Position ID is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">SAP/Success Factor ID</label>
                    <dx-text-box
                        [(value)]="details.sapSuccessFactorId"
                        [maxLength]="50"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="SAP/Success Factor ID is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Employee ID</label>
                    <dx-text-box
                        [(value)]="details.employeeId"
                        [maxLength]="50"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="Employee ID is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">User ID</label>
                    <dx-text-box
                        [(value)]="details.nestleUserId"
                        [maxLength]="50"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="User ID is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Email</label>
                    <dx-text-box
                        [(value)]="details.email"
                        [maxLength]="150"
                        [showClearButton]="true"
                        stylingMode="filled"
                        valueChangeEvent="input"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="email"></dxi-validation-rule>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="Email is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Next Password Expiry Date</label>
                    <dx-date-box
                        [(value)]="details.nextPasswordExpiryDate"
                        type="date"
                        [displayFormat]="dateFormat"
                        [showClearButton]="true"
                        stylingMode="filled"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="custom" [validationCallback]="requiredOnConfirm" [reevaluate]="true" message="Next Password Expiry Date is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                    @if (isPasswordResetRequired) {
                        <div class="text-warning small mt-1">
                            <i class="fa-light fa-circle-exclamation me-1"></i>Password reset required
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <app-nestle-deactivation-history [userId]="userId"></app-nestle-deactivation-history>
}
